//
// The API's TenantDTO in camelCase: GET tenants/me, POST tenants, the tenants of the login answer and of
// GET tenant/user.
//
export default class TenantDTO {
  id: string;

  parentId?: string;

  topLevelParentTenantId?: string;

  identityProviderType?: number;

  providerTenantId?: string;

  name: string;

  created?: string;

  subscriptionType?: number;

  subscriptionEnd?: string;

  timeZoneCode?: string;

  color?: string;

  currentUserLicensed?: boolean;

  constructor() {
    this.id = '';
    this.name = '';
  }
}

//
// POST tenants: start an organization for the directory of the signed-in user.
//
export class CreateTenantDTO {
  name: string;

  constructor(name: string) {
    this.name = name;
  }
}
